import React from 'react';
import starIcon from '../assets/starIcon.svg';
import MapPinIcon from '../assets/mapPin.svg';
import { useNavigate } from 'react-router-dom';
import CountryStore from '../store/CountryStore';
import CategoryStore from '../store/CategoryStore';

function SuggestedCard({ logo, name, address, slug }) {
  const navigate = useNavigate();
  const globalCountry = CountryStore((state) => state.country);
  const globalCategory = CategoryStore((state) => state.category);

  function handleClick(){
    const formattedCountry = globalCountry.replace(/\s+/g, '-').toLowerCase();
    const formattedCategory = globalCategory.replace(/\s+/g, '-').toLowerCase();
    const formattedSlug = slug.includes('-') ? slug : `${slug}-`
    navigate(`/${formattedCountry}/${formattedCategory}/${formattedSlug}`, {state : {slug}});
  }
  return (
    <button onClick={handleClick} className="flex flex-col lg:flex-row bg-white border border-[#D9D9D9] rounded-md shadow w-full max-w-full transition-transform transform hover:scale-105">
      {/* Image Section */}
      <div className="flex-shrink-0 lg:w-36 lg:h-36 h-36 overflow-hidden">
        <img
          src={`https://elsopro.com/vendor_images/images/${logo}`}
          alt={name}
          className="w-full h-full object-contain p-2"
        />
      </div>

      {/* Content Section */}
      <div className="flex flex-col flex-grow p-3 text-left overflow-hidden">
        {/* Title */}
        <h3 className="text-lg text-[#111827] mb-2 font-semibold break-all">
          {name}
        </h3>
        {/* Address with forced word breaking */}
        <div className="flex items-start text-sm mb-2">
          <p className="break-all w-full overflow-hidden">{address}</p>
        </div>

        {/* <div className="flex items-center text-gray-500 text-sm">
          <img src={MapPinIcon} alt="Map Pin Icon" className="mr-2 w-4 h-4" />
          <span>0.5 km from center</span>
        </div> */}
      </div>
    </button>
  );
}

export default SuggestedCard;